import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CareerCategory, CareerPath, Industry } from '@backrs_ui/common-ui';

import {
  CareerPathEnjoyment,
  CareerPathMeaning,
  CareerPathRole,
} from '@backrs_ui/grow-ui/src/models/models';

import {
  CareerPathContentResponse,
  fetchCareerPathsAndRoles,
  mapCareerPathResponseToCareerPath,
} from './thunks/careerPath.thunk';

type CareerPathState = Readonly<{
  careerCategories: CareerCategory[];
  careerPaths: CareerPath[];
  careerPathRoles: CareerPathRole[];
  careerPathMeanings: CareerPathMeaning[];
  careerPathEnjoyments: CareerPathEnjoyment[];
  industries: Industry[];
  loading?: boolean;
  error?: string;
}>;

const initialState: CareerPathState = {
  careerCategories: [],
  careerPaths: [],
  careerPathRoles: [],
  careerPathMeanings: [],
  careerPathEnjoyments: [],
  industries: [],
};

export const careerPathSlice = createSlice({
  name: 'careerState',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCareerPathsAndRoles.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(
        fetchCareerPathsAndRoles.fulfilled,
        (state, action: PayloadAction<CareerPathContentResponse>) => {
          state.careerCategories = action.payload.careerCategories;
          state.careerPaths = mapCareerPathResponseToCareerPath(action.payload.careerPaths);
          state.careerPathRoles = action.payload.careerPathRoles;
          state.careerPathMeanings = action.payload.careerPathMeanings;
          state.careerPathEnjoyments = action.payload.careerPathEnjoyments;
          state.industries = action.payload.industries;
          state.loading = false;
        },
      )
      .addCase(fetchCareerPathsAndRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});
